import { Chart } from 'react-chartjs-2';
import { registerChartComponents } from './chartUtils';
import { BarChartProps, BarChartOptions, BarChartData } from './types';

// Register necessary Chart.js components
registerChartComponents();

const HomeBarChart: React.FC<BarChartProps> = ({ title, barChartData, xlabel }) => {
  const options: BarChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      title: { display: true, text: title }
    },
    scales: {
      y: {
        type: 'linear',
        position: 'left',
        title: { display: false, text: 'Kg. Fibra' }
      },
      x: {
        ticks: {
          maxRotation: 45,
          minRotation: 0,
          font: { size: 8 }
        }
      }
    },
  };

  const data: BarChartData = {
    labels: barChartData.map(item => item.label),
    datasets: [{
      type: 'bar',
      label: xlabel,
      backgroundColor: '#a0a9b0',
      data: barChartData.map(item => item.total_kg_fibra),
      borderColor: 'gray',
      borderWidth: 1,
    }]
  };

  return <Chart type='bar' data={data} options={options} />;
};

export default HomeBarChart;
